@if (type === 'checkbox') {
  <div class="checkbox-container">
    <input
      type="checkbox"
      [id]="id"
      [formControl]="ngControl.control | formControl"
      [required]="required"
      class="checkbox-input"
    />
    @if (label) {
      <label for="{{ id }}" class="checkbox-label">{{ label }}</label>
    }
  </div>
} @else {
  @if (label) {
    <div class="custom-label">
      <label for="{{ id }}">{{ label }}</label>
    </div>
  }
  <div class="input-container">
    <input
      [ngClass]="{
        'input-box': true,
        'image-included': !!icon,
        'hide-icon-included': showHide,
        'input-error': ngControl.control?.dirty && !ngControl.control?.valid
      }"
      [formControl]="ngControl.control | formControl"
      [type]="type"
      [id]="id"
      [placeholder]="placeholder"
      [required]="required"
      (input)="onInputChange()"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
    />

    @if (!!icon) {
      <div class="image-container">
        <img ngSrc="{{ '../../../assets/images/' + icon }}" width="24" height="24" aria-hidden="true" alt=""/>
      </div>
    }
    @if(isShowPasswordReqs && ngControl.invalid) {
      <div class="password-validation-container">
        <div class="tip left">
          <app-password-requirements [control]="ngControl.control | formControl"/>
        </div>
      </div>
    }
    @if (!!showHide) {
      <div 
        class="image-container hide-icon-container" 
        role="button" 
        tabindex="0" 
        (click)="showHideText()" 
        (keydown.enter)="showHideText()" 
        (keydown.space)="showHideText()" 
        [attr.aria-label]="type === 'password' ? 'Show password' : 'Hide password'"
      >
        @if (this.type === 'password') {
          <fa-icon [icon]="faEyeSlash"></fa-icon>
        } @else {
          <fa-icon [icon]="faEye"></fa-icon>
        }
      </div>
    }
  </div>
}
<control-messages [control]="ngControl.control | formControl" [label]="label"/>
